import $ from 'jquery';
import _ from 'underscore';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';
import BaseView from '../../core/baseView';
import * as registry from '../../../home24/core/registry';

/*
 * tracking for quick view on new list view
 * most of data coming through pub/sub from shop-app
 * check https://jira.home24.de/browse/REBOOT-20912 for details
 */
export default BaseView.extend({

    initialize: function () {
        $.subscribe('openOverlay.quickView:tracking', _.bind(this.onQuickViewOpen, this));
        $.subscribe('leaveOverlay.quickView:tracking', _.bind(this.onQuickViewLeave, this));
        $.subscribe('articleChange.quickView:tracking', _.bind(this.onArticleChange, this));
        $.subscribe('galleryClicked.quickView:tracking', _.bind(this.onGalleryClicked, this));
    },

    events: {
        'click .js-article-tile__quick-view-link': 'onQuickViewLinkClick'
    },

    // extra info if coming from deeplink or link click
    articleWasClicked: false,
    extraArticleData: {},

    // after clicking we know more info about article
    onQuickViewLinkClick: function () {
        this.articleWasClicked = true;
    },

    cleanData: function () {
        this.articleWasClicked = false;
        this.extraArticleData = {};
    },

    // try to get extra data from listView tracking data
    getExtraArticleData: function (sku) {
        var result = {};

        if (registry.get('listView.trackingData') && registry.get('listView.trackingData')[sku]) {
            result = registry.get('listView.trackingData')[sku];
        }

        return result;
    },

    push: function (data) {
        window.dataLayer.push(data);
    },

    // quick view open
    onQuickViewOpen: function (event, data) {
        var onArticleClickData;

        // try to get extra data, will success if article is on the page
        this.extraArticleData = this.getExtraArticleData(data.child.sku);

        this.articleRendered(data);

        // trigger this only if coming from quick view link click, not from deeplink
        if (this.articleWasClicked) {
            onArticleClickData = this.prepareOnArticleClickData(data);
            this.push(onArticleClickData);
        }
    },

    // only on article click and quick view opened
    prepareOnArticleClickData: function (data) {
        var subCategory = getCurrentDataLayer().pageProdGroup;

        // ie. 'Catalog - Möbel'
        var categoryWithSubCategory = this.extraArticleData.list + ' - ' + subCategory;

        return {
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        action: 'click',
                        list: categoryWithSubCategory
                    },
                    products: [{
                        name: data.child.name + ' - ' + data.child.variantName,
                        id: data.child.sku,
                        price: data.child.price.trackingPrice.single,
                        brand: this.extraArticleData.brand,
                        category: this.extraArticleData.category,
                        variant: data.child.variantName,
                        position: this.extraArticleData.position,
                        dimension64: this.extraArticleData.dimension64
                    }]
                }
            }
        };
    },

    // article rendered, trigger on every rerender too
    articleRendered: function (data) {
        this.push(this.prepareOnArticleRenderedData(data));
        this.push(this.prepareOnArticleRenderedEnhancedData(data));
    },

    prepareOnArticleRenderedData: function (data) {
        var currentDataLayer = getCurrentDataLayer();

        return {
            pageType: 'QuickView',
            event: 'QV_open',
            productConfigSKU: data.parentSku,
            productName: data.child.name + ' - ' + data.child.variantName,
            productSimpleSKU: data.child.sku,
            productPrice: this._getArticlePrice(data),
            productBrand: this.extraArticleData.brand || '',
            variantName: data.child.variantName,
            purchasingCategories: this.extraArticleData.category ? this.extraArticleData.category.split('/') : '',
            visitorDemographicInfo: currentDataLayer.visitorDemographicInfo,
            visitorLoginState: currentDataLayer.visitorLoginState,
            webserver: currentDataLayer.webserver
        };
    },

    prepareOnArticleRenderedEnhancedData: function (data) {

        var subCategory;
        var categoryWithSubCategory;

        subCategory = getCurrentDataLayer().pageProdGroup;

        if (this.extraArticleData.list) {
            // ie. 'Catalog - Möbel'
            categoryWithSubCategory = this.extraArticleData.list + ' - ' + subCategory;
        }

        return {
            event: 'productDetail',
            ecommerce: {
                detail: {
                    actionField: {
                        list: categoryWithSubCategory || subCategory
                    },
                    products: [{
                        name: data.child.name + ' - ' + data.child.variantName,
                        id: data.child.sku,
                        price: this._getArticlePrice(data),

                        // when coming from deeplink this data might be not available
                        brand: this.extraArticleData.brand || '',
                        category: this.extraArticleData.category || '',
                        variant: data.child.variantName,

                        // means pdpType :/
                        dimension65: 'pdp_qv',

                        // means deliveryTime in days :/
                        dimension64: this._getArticleDeliveryTime(data)
                    }]
                }
            }
        };
    },

    // if article is not sellable, there is no price object
    _getArticlePrice: function (data) {
        var price = '';

        if (data.child.price) {
            price = data.child.price.trackingPrice.single;
        }

        return price;
    },

    // if article is not sellable, there is no delivery object
    _getArticleDeliveryTime: function (data) {
        var delivery = '';

        if (data.child.delivery) {
            delivery = data.child.delivery.days;
        }

        return delivery;
    },

    // quick view leave
    onQuickViewLeave: function (event, data) {

        var onOverlayLeaveData = this.prepareOnOverlayLeaveData(data);

        this.push(onOverlayLeaveData);

        // remove extra data set by opening quick view
        this.cleanData();
    },

    prepareOnOverlayLeaveData: function (data) {
        return {
            simple_sku: data.child.sku,
            parent_sku: data.parentSku,

            // close | add_to_cart | pdp_link
            click_position: data.reason,
            event: 'QV_leave'
        };
    },

    // article change
    onArticleChange: function (event, data) {
        this.push(this.prepareOnArticleChangeData(data));

        this.articleRendered(data);
    },

    prepareOnArticleChangeData: function (data) {
        return {
            simple_sku: data.child.sku,
            parent_sku: data.parentSku,

            // mvc attribute id
            filter_used: data.attributeId,
            event: 'QV_filter_interaction'
        };
    },

    // gallery click
    onGalleryClicked: function (event, data) {
        this.push(this.prepareOnGalleryClickedData(data));
    },

    prepareOnGalleryClickedData: function (data) {
        return {
            simple_sku: data.child.sku,
            parent_sku: data.parentSku,

            // up or down
            filter_used: data.direction,
            event: 'QV_image_interaction'
        };
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/catalog/quickViewEvents.js
 **/